// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p[data-v-fe0f7ca4]{white-space:nowrap}p .N[data-v-fe0f7ca4]{display:inline-block;width:1em}.mask[data-v-fe0f7ca4]{font-size:9px}p .section[data-v-fe0f7ca4]{display:inline-block}p .section+.section[data-v-fe0f7ca4]{margin-left:2em}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
